module.exports = __webpack_public_path__ + "static/media/alarm-exclamation.d15c6401.svg";